import { render } from "./AssessmentScreen.vue?vue&type=template&id=bc048052"
import script from "./AssessmentScreen.vue?vue&type=script&lang=ts"
export * from "./AssessmentScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script